import { formatDate } from '@/helpers/formatter';

export const createDownloadLink = (data, doc) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('target', '_blank');
  link.setAttribute('download', `${formatDownloadLabel(createLinkLabel(doc))}.pdf`);
  document.body.appendChild(link);
  link.click();
};

export const createLinkLabel = (document) => {
  let label = '';
  switch (document.submission_type) {
    case 'firstapplication':
      label = 'Erstantrag';
      break;
    case 'carelevelupgrade':
      label = 'Höherstufungsantrag';
      break;
  }
  return label + ' vom ' + formatDate(document.doc_created_at);
};

export const formatDownloadLabel = (string) => {
  const chars = { '.': '-', ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' };
  for (const x in chars) {
    string = string.replaceAll(x, chars[x]);
  }
  return string;
};
